/* tslint:disable */
type PerfilEnum =
  'ESCRITORIO' |
  'GESTOR' |
  'SENIOR' |
  'ADM' |
  'GERENTE' |
  'SUPERINTENDENTE';
module PerfilEnum {
  export const ESCRITORIO: PerfilEnum = 'ESCRITORIO';
  export const GESTOR: PerfilEnum = 'GESTOR';
  export const SENIOR: PerfilEnum = 'SENIOR';
  export const ADM: PerfilEnum = 'ADM';
  export const GERENTE: PerfilEnum = 'GERENTE';
  export const SUPERINTENDENTE: PerfilEnum = 'SUPERINTENDENTE';
  export function values(): PerfilEnum[] {
    return [
      ESCRITORIO,
      GESTOR,
      SENIOR,
      ADM,
      GERENTE,
      SUPERINTENDENTE
    ];
  }
}

export { PerfilEnum }